export default "__VITE_ASSET__bc44c242__"